import React, { useState } from "react";
import Objective from "./Objective";
import Plotting from "./plotting/Plotting";
import Computing from "./computing/Computing";
import Heading from "./heading/Heading";

/**
 * Main Circular Tunnel Component
 * Routes between different views: Objective, Plotting, Computing, Heading
 */
const Circular = (props) => {
  const [isStep, setStep] = useState("objective");

  return isStep === "objective" ? (
    <Objective setstep={setStep} />
  ) : isStep === "orientation" ? (
    <Plotting setstep={setStep} />
  ) : isStep === "computing" ? (
    <Computing setstep={setStep} />
  ) : (
    <Heading />
  );
};

export default Circular;
